export default "__VITE_ASSET__Cu11lN90__"